import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import classNames from 'classnames';
import React, { SyntheticEvent } from 'react';
import { DialogSidebar, SidePanelSizes } from './DialogSidebar';
import styles from './StyledDialog.module.scss';

export class StyledDialogCore extends React.Component<
    DialogProps & {
        actions?: React.ReactNode;
        open: boolean;
        size?: 'xxxs' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | false;
        modal?: boolean;
        fullHeight?: boolean;
        autoHeightBody?: boolean;
        titleComponent?: React.ReactNode;
        actionsComponent?: React.ReactNode;
        alertContent?: React.ReactNode;
        contentComponent?: React.ReactNode;
        testId: string;
        preventSideBarCollapse?: boolean;
        sidePanelSize?: SidePanelSizes;
        onExited?(): void;
        onRequestClose?(event: SyntheticEvent<{}>): void;
        sidebarRender?(props: { collapsed: boolean }): React.ReactNode;
    }
> {
    public static muiName = 'Dialog';

    public state = {
        sidebarCollapsed: window.innerWidth < 1279
    };

    public toggleSidebar = (): void => {
        this.setState({
            sidebarCollapsed: !this.state.sidebarCollapsed
        });
    };

    public render() {
        const {
            size,
            modal,
            fullHeight,
            autoHeightBody,
            open,
            onRequestClose,
            sidebarRender,
            titleComponent,
            contentComponent,
            actionsComponent,
            alertContent,
            children,
            testId,
            preventSideBarCollapse,
            sidePanelSize,
            ...otherProps
        } = this.props;

        const dialogBodyStyles = classNames(styles.dialogBody, {
            [styles.smallest]: size === 'xxxs',
            [styles.extraSmall]: size === 'xs' || size === 'xxs',
            [styles.small]: size === 'sm',
            [styles.medium]: size === 'md',
            [styles.large]: size === 'lg',
            [styles.autoHeightBody]: autoHeightBody
        });

        const sideBarOpen = !!preventSideBarCollapse ? true : !!sidebarRender && !this.state.sidebarCollapsed;

        const mainAreaStyles = classNames(styles.mainArea, {
            [styles.sideBarLockedOpen]: !!preventSideBarCollapse,
            [styles.hasSideBar]: !!sidebarRender,
            [styles.sideBarOpen]: sideBarOpen,
            [styles.sideBarSmallOpen]: sidePanelSize === SidePanelSizes.Small
        });

        const paperStyles = classNames(styles.dialogPaper, {
            [styles.fullHeight]: fullHeight,
            [styles.extraExtraSmallWidth]: size === 'xxs',
            [styles.large]: size === 'lg'
        });

        const maxWidth = size === 'xxs' || size === 'xxxs' ? 'xs' : size;

        return (
            <Dialog
                {...otherProps}
                data-test-id={`dialog_${testId}`}
                classes={{
                    paper: paperStyles,
                    paperWidthXs: styles.extraSmallWidth,
                    paperWidthSm: styles.smallWidth,
                    paperWidthMd: styles.mediumWidth,
                    paperFullScreen: styles.largeWidth
                }}
                fullWidth
                maxWidth={maxWidth}
                onClick={this.handleDialogBodyClick}
                disableBackdropClick={modal}
                open={open}
                onExited={this.props.onExited}
                onClose={onRequestClose}
            >
                {titleComponent}
                <div className={dialogBodyStyles}>
                    {sidebarRender && (
                        <DialogSidebar
                            preventSideBarCollapse={preventSideBarCollapse}
                            sidePanelSize={sidePanelSize}
                            collapsed={this.state.sidebarCollapsed}
                            onToggle={this.toggleSidebar}
                            sidebarRender={sidebarRender}
                        />
                    )}
                    <div className={mainAreaStyles}>
                        {alertContent}
                        {contentComponent}
                        {actionsComponent}
                        {children}
                    </div>
                </div>
            </Dialog>
        );
    }

    private handleDialogBodyClick = (event: React.MouseEvent) => {
        event.stopPropagation();
    };
}
